import { z } from 'zod';
import { EntityIdSchema } from './common';

/**
 * Resumen agregado de una cohorte (KPIs).
 * Backend NO implementado aún (ver §Backend gaps del plan).
 */
export const ReporteResumenSchema = z.object({
  cohorte_id: EntityIdSchema,
  total_participantes: z.number().int().nonnegative(),
  acreditados: z.number().int().nonnegative(),
  no_acreditados: z.number().int().nonnegative(),
  porcentaje_promedio_asistencia: z.number().min(0).max(1),
  trimestres: z.array(
    z.object({
      nombre: z.string(),
      asistencia_promedio: z.number().min(0).max(1),
    }),
  ),
});
export type ReporteResumen = z.infer<typeof ReporteResumenSchema>;

/**
 * Fila del reporte por participante.
 */
export const ReportePorParticipanteFilaSchema = z.object({
  participante_id: EntityIdSchema,
  nombre: z.string(),
  apellido: z.string(),
  cedula: z.string(),
  asistencia_por_sesion: z.record(z.string(), z.enum(['asistio', 'falta', 'justificada'])),
  porcentaje_asistencia: z.number().min(0).max(1),
  acreditado: z.boolean(),
});
export type ReportePorParticipanteFila = z.infer<typeof ReportePorParticipanteFilaSchema>;

export const ReportePorParticipanteResponseSchema = z.object({
  data: z.array(ReportePorParticipanteFilaSchema),
});
export type ReportePorParticipanteResponse = z.infer<typeof ReportePorParticipanteResponseSchema>;

/**
 * Fila del reporte por sesión.
 */
export const ReportePorSesionFilaSchema = z.object({
  sesion_id: EntityIdSchema,
  sesion_tema: z.string().nullable(),
  fecha: z.string(),
  total_escaneados: z.number().int().nonnegative(),
  porcentaje_asistencia_puntual: z.number().min(0).max(1),
  inasistentes: z.array(
    z.object({ participante_id: EntityIdSchema, nombre: z.string(), apellido: z.string() }),
  ),
});
export type ReportePorSesionFila = z.infer<typeof ReportePorSesionFilaSchema>;

export const ReportePorSesionResponseSchema = z.object({
  data: z.array(ReportePorSesionFilaSchema),
});
export type ReportePorSesionResponse = z.infer<typeof ReportePorSesionResponseSchema>;

/**
 * Esquemas para la Sábana Consolidada de Acreditación de Asistencia.
 */
export const SabanaSesionInfoSchema = z.object({
  id: EntityIdSchema,
  fecha: z.string(),
  tema: z.string().nullable(),
  numero: z.number().int().optional(),
});
export type SabanaSesionInfo = z.infer<typeof SabanaSesionInfoSchema>;

export const SabanaItemSchema = z.object({
  participante_id: EntityIdSchema,
  cedula: z.string(),
  nombre: z.string(),
  apellido: z.string(),
  pnf: z.string().nullable(),
  sede: z.string().nullable(),
  sesiones: z.record(z.string(), z.enum(['P', 'T', 'J', 'A'])),
  asistencias_validas: z.number().int().nonnegative(),
  total_sesiones: z.number().int().nonnegative(),
  porcentaje: z.number().min(0).max(100),
  acreditado: z.boolean(),
  estado_acreditacion: z.enum(['Acreditable', 'No Acreditable']),
});
export type SabanaItem = z.infer<typeof SabanaItemSchema>;

export const SabanaResponseSchema = z.object({
  cohorte: z.object({
    id: EntityIdSchema,
    nombre: z.string().nullable(),
  }),
  sesiones: z.array(SabanaSesionInfoSchema),
  items: z.array(SabanaItemSchema),
  totales: z.object({
    total_participantes: z.number().int().nonnegative(),
    acreditables: z.number().int().nonnegative(),
    no_acreditables: z.number().int().nonnegative(),
    porcentaje_acreditacion: z.number().min(0).max(100),
  }),
});
export type SabanaResponse = z.infer<typeof SabanaResponseSchema>;